import { SelectOption } from '@touche-lts/panel-ui/dist'
// import { RootStore } from 'mobx-stores/root-store'
import { TriggerSearchFunc, ActionhistoryTableBase } from 'mobx-stores/utils'
import { ActionHistoryTableStatus } from 'mobx-stores/utils/action-history-table-base/action-history-table-base.types'
import { PeriodFilter } from 'models'
import { getSelectOptions } from 'utilities'
import { User } from 'services'

export class ActionHistoryStore extends ActionhistoryTableBase {
  private rootStore: any

  constructor(rootStore: any) {
    super()
    this.rootStore = rootStore
  }

  // ACTIONS
  public setUserId: (userId: number) => void = (userId) => {
    this.userId = userId;
  }

  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
    if (this.userId !== null) {
      const id = this.userId;
      return this.triggerSearchForUser({ ...options, id });
    }

    if (User.isStoreAdmin) {
      return this.triggerSearchForUser({ ...options, id: User.id });
    }

    const searchData = await this.rootStore.generalStore.api.actionHistoryApi.getActionHistory(
      this.ordersFilter,
      { pageQueryParams: this.getPageQueryParams(options?.resetPageNumber) }
    )

    this.handleSearchResult(searchData)
  }

  public triggerSearchForUser: TriggerSearchFunc = async (options): Promise<void> => {
    if (this.userId === null) {
      this.userId = Number(options.id);
    }
    const searchData = await this.rootStore.generalStore.api.actionHistoryApi.getUserActionHistory(
      options?.id,
      this.ordersFilter,
      { pageQueryParams: this.getPageQueryParams(options?.resetPageNumber) }
    )

    this.handleSearchResult(searchData)
  }

  // COMPUTED
  public get ordersPeriodFilterOptions(): SelectOption<PeriodFilter>[] {
    return getSelectOptions(PeriodFilter)
  }

  public get statusTableHeader(): SelectOption<ActionHistoryTableStatus>[] {
    return Object.values(ActionHistoryTableStatus).map(type => ({
      label: type,
      value: type
    }))
  }

  // METHODS
  public statusShown(status: string): string {
    return (status.charAt(0).toUpperCase() + status.slice(1)).replaceAll('_', ' ');
  }

}
